var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 9H16M9 15H21M9 21H21M4 28H26C26.5523 28 27 27.5523 27 27V9.28197C27 8.77919 26.8106 8.29485 26.4696 7.92541L21.5939 2.64344C21.2153 2.23328 20.6825 2 20.1243 2H4C3.44772 2 3 2.44772 3 3V27C3 27.5523 3.44772 28 4 28Z",
    stroke: "#FF6700",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/report.4d5904db4e0d6b4eab33bbfcbccc7e2e.svg";
export { ForwardRef as ReactComponent };